import { render, staticRenderFns } from "./ColorSelect.vue?vue&type=template&id=4455775c&"
import script from "./ColorSelect.vue?vue&type=script&lang=js&"
export * from "./ColorSelect.vue?vue&type=script&lang=js&"
import style0 from "./ColorSelect.vue?vue&type=style&index=0&id=4455775c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports